import {Button, Dialog, DialogContent, TextField, Tooltip} from "@mui/material";
import './styless.scss'
import CloseIcon from "@mui/icons-material/Close";
import {useEffect, useState} from "react";
import {createInvitationCode, createInvitationStatus} from "../../api/authority";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import ContentCopyOutlined from '@mui/icons-material/ContentCopyOutlined';
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {getLocalStorage} from "../../util/storage";
import {useLocation} from "react-router-dom";

export default function Invitation (props: {labelDialogOpen: boolean, handleSetLabelDialogClose: ()=>void}) {
    const {labelDialogOpen, handleSetLabelDialogClose} = props;

    const [invitationUrl, setInvitationUrl] = useState<string>('')

    const [invitationCode, setInvitationCode] = useState<string>('')

    const [invitedUserCount, setInvitedUserCount] = useState<number>(0)

    const [rewardSum, setRewardSum] = useState<number>(0)

    const [copyTooltipOpen, setCopyTooltipOpen] = useState(false)
    const [copyTooltipCodeOpen, setCopyTooltipCodeOpen] = useState(false)
    const [copyTooltipText, setCopyTooltipText] = useState("")
    const [tooltipOpenTimeout, setTooltipOpenTimeout] = useState<NodeJS.Timeout | null>(null)

    const {trackInvitationLinkCopy, trackInvitationCodeCopy, trackJoinQqgroupClick} = useMatomoTrackingPoint()

    const memberInfo = useSelector((state: RootState) => state.member.memberInfo);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const boardId = queryParams.get('boardId') || getLocalStorage('boardId') || undefined;

    const domain = window.location.origin

    useEffect(() => {
        if(labelDialogOpen) {
            createInvitationCode().then(item => {
                if(item?.code) {
                    setInvitationCode(item?.code)
                    setInvitationUrl(`${domain}/?invitationCode=${item?.code}`)
                }

            })
            createInvitationStatus().then(item => {
                // 拿不到数据就保持现状
                if (!item) return
                // 不能写成 if (item.invitedCount)：真值判断会跳过 0，
                // 跨月清零后同一会话里重开弹窗会残留上一次的非 0 值
                setInvitedUserCount(item.invitedCount ?? 0)
                setRewardSum(item.rewardSum ?? 0)
            })
        }
    }, [labelDialogOpen]);

    const handleCopy = (text: string, successMessage: string, isCode?: boolean) => {
        setCopyTooltipOpen(false)
        setCopyTooltipCodeOpen(false)
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopyTooltipText(successMessage)
            if (isCode) {
              setCopyTooltipCodeOpen(true)
            }else {
              setCopyTooltipOpen(true)
            }
          
          // 如果已有定时器，先清除
          if (tooltipOpenTimeout) {
            clearTimeout(tooltipOpenTimeout)
          }

          // 设置3秒后关闭tooltip
          const timeout = setTimeout(() => {
            setCopyTooltipOpen(false)
            setCopyTooltipCodeOpen(false)
          }, 3000)
          
          setTooltipOpenTimeout(timeout)
        })
        .catch((err) => {
          console.error("复制失败: ", err)
          setCopyTooltipText("复制失败")
            if (isCode) {
                setCopyTooltipCodeOpen(true)
            }else {
                setCopyTooltipOpen(true)
            }
          
          if (tooltipOpenTimeout) {
            clearTimeout(tooltipOpenTimeout)
          }
          
          const timeout = setTimeout(() => {
            setCopyTooltipOpen(false)
            setCopyTooltipCodeOpen(false)
          }, 3000)
          
          setTooltipOpenTimeout(timeout)
        })
    }

    return <div>
        <Dialog
            open={labelDialogOpen}
            onClose={handleSetLabelDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="invitation-dialog"
        >
            <DialogContent>
                <div>
                    {/*<div className="invitation-header">
                        <div></div>
                        <div className="invitation-title">领取免费水滴</div>
                        <div onClick={handleSetLabelDialogClose}><CloseIcon sx={{ width: 30, height: 30, marginTop: '6px' }} /></div>
                    </div>*/}
                    <div className='invitation-block'>
{/*                        {
                            !memberInfo?.isGetWelcomePoint && <>
                                <div className='invitation-item'>
                                    <div className='invitation-item-banner' style={{backgroundColor: '#E1EDFB'}}>
                                        <div>加入社群，领新用户欢迎水滴</div>
                                        <div>萌新福利！社群公告可领取新人专属礼品码，一键兑换 <span>50</span> 水滴</div>
                                    </div>
                                    <div className='dialog-line'>● 加社群好啊，新人专属水滴福利，得加啊~</div>
                                    <div className='dialog-line'>● 加社群好啊，遇到BUG随时反馈，得加啊~</div>
                                    <div className='dialog-line'>● 加社群好啊，礼品码不定时掉落，得加啊~</div>
                                    <div className='join-community'
                                         onClick={() => {
                                             const device_id = getLocalStorage('device_id') || "";
                                             const page_id = window.location.href;
                                             trackJoinQqgroupClick({
                                                 device_id,
                                                 page_id,
                                                 board_id: boardId
                                             });
                                             window.open('https://qm.qq.com/q/DdeNxVg01i', '_blank')
                                         }}>点击加入社群
                                    </div>
                                </div>
                                <div style={{width: '20px'}}></div>
                            </>
                        }*/}
                        <div className='invitation-item'>
                            <div className='invitation-item-banner'
                                 style={{backgroundColor: 'var(--c-warm-bg)'}}>
                                <div>邀请朋友，一起领水滴</div>
                                <div>感恩回馈！分享邀请码，新人成功注册后，双方均可获得 <span>25</span> 水滴</div>
                                <div>每月最多可领取 <span>1500</span> 邀请活动水滴</div>
                            </div>
                            <div className="invitation-stats">
                                <div className="invitation-stat-card">
                                    <div className="invitation-stat-title">本月邀请用户</div>
                                    <div className="invitation-stat-value">{invitedUserCount}</div>
                                </div>
                                <div className="invitation-stat-card">
                                    <div className="invitation-stat-title">本月获得水滴</div>
                                    <div className="invitation-stat-value">
                                        {rewardSum}<span className="invitation-stat-value-sub">/1500</span>
                                    </div>
                                </div>
                            </div>
                            <div className="invitation-section-title">邀请链接</div>
                            <div className="invitation-input-container">
                            <TextField
                                    placeholder="输入邀请码"
                                    translate='no'
                                    variant="outlined"
                                    size="small"
                                    className="invitation-input"
                                    value={invitationUrl}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                                    InputProps={{
                                        endAdornment: (
                                            <Tooltip
                                                title={copyTooltipText}
                                                open={copyTooltipOpen}
                                                arrow
                                                placement="top"
                                            >
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: 'pointer'
                                            }} onClick={() => {
                                                handleCopy(invitationUrl, "邀请链接已复制到剪贴板")
                                                trackInvitationLinkCopy()
                                            }}><ContentCopyOutlined fontSize='small' /></div></Tooltip>
                                        )
                                    }}
                                />
                            </div>
                            <div className="invitation-section-title">邀请码</div>
                            <div className="invitation-input-container">
                                <TextField
                                    placeholder="输入邀请码"
                                    translate='no'
                                    variant="outlined"
                                    size="small"
                                    className="invitation-input"
                                    value={invitationCode}
                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                                    InputProps={{
                                        endAdornment: (
                                            <Tooltip
                                                title={copyTooltipText}
                                                open={copyTooltipCodeOpen}
                                                arrow
                                                placement="top"
                                            >
                                            <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: 'pointer'
                                            }}  onClick={() => {
                                                handleCopy(invitationCode, "邀请码已复制到剪贴板", true)
                                                trackInvitationCodeCopy()
                                            }}><ContentCopyOutlined fontSize='small' /></div></Tooltip>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    </div>
}